import {
	Box,
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Select,
	Stack,
	Text,
	Textarea,
	useToast,
} from '@chakra-ui/react';

import { crearActividad, updateActividad } from '../../../services/actividades';
import {
	errorNotification,
	okNotification,
} from '../../../utils/Notificaciones';
import EasyDatePickerWithTime from '../../EasyDatePicker/EasyDatePickerWithTime';
import { useState } from 'react';
import { TIPOS_CITAS } from '../../../data/constants';
import { createEvent } from '../../../services/agenda';

const PropuestaProcesoGuiado = ({ isOpen, onClose, onClosePadre, datos }) => {
	const toast = useToast();
	const [crearCita, setCrearCita] = useState(false);
	const [fechaInicio, setFechaInicio] = useState(new Date());
	// fechaFin = fechaInicio + 1 hora
	const [fechaFin, setFechaFin] = useState(
		new Date(new Date().getTime() + 30 * 60000),
	);
	const [comentario, setComentario] = useState('');

	const handleSubmit = async e => {
		e.preventDefault();
		try {
			if (crearCita) {
				// Actualizar cita de alquiler/venta
				if (datos.actividadUuid) {
					await updateActividad(datos.actividadUuid, datos);
				} else {
					await crearActividad({
						...datos,
					});
				}

				const crearNueva = await crearActividad({
					...datos,
					tipo_actividad: 'Propuesta',
					modalidad_contacto: datos.modalidad_contacto,
					estado_actividad: 'Programada',
					descripcion: comentario,
					fecha_finalizacion: null,
					actividadUuid: null, // No se envía actividadUuid para crear una nueva
				});

				await createEvent({
					entidad_relacionada: 'Inmueble',
					fechaInicio: fechaInicio || new Date(),
					fechaFin:
						fechaFin || new Date(new Date().getTime() + 30 * 60000),
					estado: 'Programada',
					tipo: 'Propuesta',
					descripcion: comentario,
					color: TIPOS_CITAS.find(tipo => tipo.tipo === 'Propuesta')
						.color,
					responsableUuid: datos.responsableUuid,
					clienteUuid: datos.clienteUuid,
					inmuebleUuid: datos.inmuebleUuid,
					actividadeUuid: crearNueva.uuid,
				});

				okNotification('Actividad creada. Cita creada.', toast);
			} else {
				if (datos.actividadUuid) {
					await updateActividad(datos.actividadUuid, datos);
				} else {
					await crearActividad(datos);
				}

				okNotification('Actividad creada.', toast);
			}
		} catch (error) {
			errorNotification('Error al crear la actividad', toast);
		}
		onClose();
		onClosePadre();
		window.location.reload();
	};

	const handleChangeFechaFin = e => {
		const nuevaFechaInicio = new Date(e);
		setFechaInicio(nuevaFechaInicio);

		// Fecha fin = fechaInicio + 1 hora
		const nuevaFechaFin = new Date(nuevaFechaInicio.getTime() + 60 * 60000);
		setFechaFin(nuevaFechaFin);
	};

	return (
		<Modal isOpen={isOpen} onClose={onClose} size='6xl'>
			<ModalOverlay bgColor='blackAlpha.800' />
			<ModalContent>
				<ModalHeader>Proceso guiado</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Stack direction='column'>
						<Text textAlign='center'>
							¿Quieres hacer una cita de propuesta?
						</Text>
						<Select
							value={crearCita}
							onChange={e =>
								setCrearCita(e.target.value === 'true')
							}
						>
							<option value='true'>Si</option>
							<option value='false'>No</option>
						</Select>

						{crearCita && (
							<Stack direction='column'>
								<Box>
									<Text textAlign='center'>
										Fecha de inicio
									</Text>
									<EasyDatePickerWithTime
										name='fecha_inicio'
										value={fechaInicio}
										handleChange={handleChangeFechaFin}
									/>
								</Box>
								<Box>
									<Text textAlign='center'>Fecha de fin</Text>
									<EasyDatePickerWithTime value={fechaFin} />
								</Box>
								<Text textAlign='center'>Comentario</Text>
								<Textarea
									value={comentario}
									onChange={e =>
										setComentario(e.target.value)
									}
									minH='90px'
								/>
							</Stack>
						)}

						<Button
							colorScheme='blue'
							size='sm'
							mt={4}
							onClick={handleSubmit}
							isDisabled={
								crearCita &&
								(!fechaInicio || !fechaFin || !comentario)
							}
						>
							Guardar
						</Button>
					</Stack>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default PropuestaProcesoGuiado;
